import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { buildDirectionsUrl, buildDetailUrl, STORE_TYPE_PARTNER } from './helpers';
const StoreLocatorResultItem = t0 => {
  const $ = _c(36);
  const {
    store,
    index,
    onActivate
  } = t0;
  const isPartner = store?.type === STORE_TYPE_PARTNER;
  let t1;
  if ($[0] !== store) {
    t1 = buildDetailUrl(store);
    $[0] = store;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const detailUrl = t1;
  let t2;
  if ($[2] !== store) {
    t2 = buildDirectionsUrl(store);
    $[2] = store;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const directionsUrl = t2;
  const detailLabel = isPartner ? "Partner Studio Detail" : "Showroom Detail";
  let t3;
  if ($[4] !== store.city || $[5] !== store.state || $[6] !== store.zip) {
    t3 = [store.city, store.state, store.zip].filter(Boolean);
    $[4] = store.city;
    $[5] = store.state;
    $[6] = store.zip;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const addressLine = t3.join(", ");
  let t4;
  if ($[8] !== onActivate || $[9] !== store.id) {
    t4 = () => {
      if (onActivate) {
        onActivate(store.id);
      }
    };
    $[8] = onActivate;
    $[9] = store.id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleCardClick = t4;
  let t5;
  if ($[11] !== handleCardClick) {
    t5 = event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleCardClick();
      }
    };
    $[11] = handleCardClick;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleKeyDown = t5;
  const t6 = store.name || store.city;
  let t7;
  if ($[13] !== index || $[14] !== t6) {
    t7 = <div className="text-base text-brand font-bold">{index}. {t6}</div>;
    $[13] = index;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== store.street) {
    t8 = store.street && <div>{store.street}</div>;
    $[16] = store.street;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== addressLine || $[19] !== directionsUrl) {
    t9 = addressLine && <div>{addressLine}{" "}<a href={directionsUrl} target="_blank" rel="noopener noreferrer" className="text-brand underline hover:text-gray-dark" onClick={_temp}>(Direction)</a></div>;
    $[18] = addressLine;
    $[19] = directionsUrl;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== store.phone) {
    t10 = store.phone && <div>Phone: {store.phone}</div>;
    $[21] = store.phone;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8 || $[25] !== t9) {
    t11 = <div className="mt-1 text-sm text-gray leading-snug">{t8}{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== detailLabel || $[28] !== detailUrl) {
    t12 = <a href={detailUrl} className="inline-block mt-1 text-sm text-brand underline hover:text-gray-dark" onClick={_temp2}>{detailLabel}</a>;
    $[27] = detailLabel;
    $[28] = detailUrl;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== handleCardClick || $[31] !== handleKeyDown || $[32] !== t11 || $[33] !== t12 || $[34] !== t7) {
    t13 = <div className="py-3 cursor-pointer" onClick={handleCardClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>{t7}{t11}{t12}</div>;
    $[30] = handleCardClick;
    $[31] = handleKeyDown;
    $[32] = t11;
    $[33] = t12;
    $[34] = t7;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};
StoreLocatorResultItem.propTypes = {
  store: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    phone: PropTypes.string,
    type: PropTypes.number,
    rs_store_landing_page: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired,
  onActivate: PropTypes.func
};
export default StoreLocatorResultItem;
function _temp(event_0) {
  return event_0.stopPropagation();
}
function _temp2(event_1) {
  return event_1.stopPropagation();
}